import * as $ from 'jquery';
import * as angular from 'angular';

import {
  Inject,
  Injectable,
} from 'ng-metadata/core';

import { ApiService } from 'services/api.service';

export interface OrderModel {
  account: OrderModelAccount;
  billingAddress: OrderModelAddress;
  shippingAddress: OrderModelAddress;
  creditCard: {
    name: string;
  };
}

export interface OrderModelAccount {
  applicantId: string;
  primaryApplicantId: string;
  salesleadId: string;
  sessionId: string;
  firstName: string;
  lastName: string;
  email: string;
  company?: string;
  country: string;
  account?: string;
  phones: OrderModelPhone[];
}

export interface OrderModelAddress {
  address: string;
  address2: string;
  locality: string;
  region: string;
  country: string;
  postalCode: string;
  sameAsShipping?: boolean;
}

export interface OrderModelPhone {
  type: string;
  friendly_name: string;
  country: string;
  value: string;
  hint?: string;
  disabled?: boolean;
  required?: boolean;
}

@Injectable()
export class OrderService extends ApiService {
  public GW = (<any>window).GW;

  public newOrder: OrderModel = {
    account: {
      applicantId: '',
      primaryApplicantId: '',
      salesleadId: '',
      sessionId:'',
      firstName: '',
      lastName: '',
      email: '',
      company: '',
      country: this.GW.geoip.iso_code || 'US',
      phones: [
        {
          type: 'mobile',
          friendly_name: 'Mobile Number',
          country: 'US',
          value: '',
          disabled: true,
          required: true,
          hint: 'We\'ll use this number to send SMS notifications.',
        },
        {
          type: 'landline',
          friendly_name: 'Home or Office Number',
          country: 'US',
          value: '',
        },
      ],
    },
    billingAddress: {
      address: '',
      address2: '',
      locality: '',
      region: '',
      country: this.GW.geoip.iso_code || 'US',
      postalCode: '',
      sameAsShipping: true,
    },
    shippingAddress: {
      address: '',
      address2: '',
      locality: '',
      region: '',
      country: 'US',
      postalCode: '',
    },
    creditCard: {
      name: '',
    },
  };

  public order = this.$sessionStorage.$default(angular.copy(this.newOrder));

  orderCreate(data: any) {
    // HAXXX
    // Append CSRF token to request
    const config = {
      headers: {
        'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content'),
      },
    };

    return this.$http.post('/order/create', data, config)
      .catch(response => this.$q.reject(response.data));
  }

  cancelOrder(email: string, orderNumber: string) {
    const data = {
      email,
      order_number: orderNumber,
    };

    return this.postRequest('/order/cancel/direct', data);
  }

  trackOrder(email: string, orderNumber: string, portal: string) {
    const data = {
      orderNumber,
      userEmail: email,
    };

    return this.postRequest(`/etoms/order/track/${portal}`, data);
  }

  resetOrder() {
    return this.$sessionStorage.$reset();
  }

  updateAccount(data) {
    this.$sessionStorage.account = data;
  }

  /**
   * Get an available merchants for the website
   *
   * @param website
   */
  getMerchantToken(website: string = '') {
    const param = website !== '' ? `/${website}` : ''

    return this.getRequest(`/order/get/token${param}`)
  }
}



// WEBPACK FOOTER //
// ./resources/assets/js/services/order.service.ts